import { render, staticRenderFns } from "./TeacherDashboardAddAccount.vue?vue&type=template&id=5fcdde80&scoped=true"
import script from "./TeacherDashboardAddAccount.vue?vue&type=script&lang=ts"
export * from "./TeacherDashboardAddAccount.vue?vue&type=script&lang=ts"
import style0 from "./TeacherDashboardAddAccount.vue?vue&type=style&index=0&id=5fcdde80&prod&scoped=true&lang=scss"
import style1 from "./TeacherDashboardAddAccount.vue?vue&type=style&index=1&id=5fcdde80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcdde80",
  null
  
)

export default component.exports